// extracted by mini-css-extract-plugin
export var author = "style-module--author--18e6e";
export var authorWrap = "style-module--author-wrap--debc9";
export var message = "style-module--message--06cf4";
export var quote = "style-module--quote--061f6";
export var textWrap = "style-module--text-wrap--3efe7";
export var wrap = "style-module--wrap--e7490";